export interface PatientNameParts {
  salute?: string | null;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
}

export class PatientNameUtils {
  static formatFullName(patient?: PatientNameParts | null, fallbackName = ''): string {
    const salute = patient?.salute?.toString().trim() || '';
    const name = [
      patient?.firstName,
      patient?.middleName,
      patient?.lastName,
    ]
      .map((part) => part?.toString().trim())
      .filter((part): part is string => !!part)
      .join(' ');

    const fallback = fallbackName.toString().trim();
    const fullName = name || fallback;

    if (!fullName) {
      return salute;
    }

    if (!salute || fullName.toLowerCase().startsWith(salute.toLowerCase())) {
      return fullName;
    }

    return `${salute} ${fullName}`;
  }
}
